import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Globals } from './../../globals'
import { CookieService } from "ngx-cookie-service";


@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html'
})
export class GenerateReportComponent implements OnInit {
  public postId;
  public errorMessage;
  public titulo: string = "Generar informe";
  Estados: Status[];
  Reports: Report[];
  user: User;
  ConsultarShow: boolean = true;

  reportForm = this.formBuilder.group({
    fechaInicio: new FormControl(''),
    fechafin: new FormControl(''),
    estadoimportacion: new FormControl('')
  });

  constructor(private http: HttpClient, private router: Router, private formBuilder: FormBuilder, private globals: Globals, private cookies: CookieService) {
    var token = this.cookies.get("tokensessionFuncionario");
    if (token == "") {
      window.location.href = environment.redirecturl;
    }
    else {
      this.http.get<any>(`${environment.baseUrl}v1/sessionfuncionario/1?token=` + this.cookies.get("tokensessionFuncionario"))
        .subscribe({
          next: data => {
            this.user = data as User;

            this.globals.tipoDocumento = this.user.tipoDocumento;
            this.globals.numIdentificacion = this.user.numIdentificacion;
            this.globals.nombres = this.user.nombres;
            this.globals.apellidos = this.user.apellidos;
            this.globals.seccional = this.user.seccional;
            this.globals.idSeccional = this.user.idSeccional;
            this.globals.dependencia = this.user.dependencia;
            this.globals.idDependencia = this.user.idDependencia;
            this.globals.correo = this.user.correo;
            this.globals.activo = this.user.activo;
            this.globals.roles = this.user.rolesAutorizados.split(",");

            for (let i = 0; i < this.globals.roles.length; i++) {
              if (this.globals.roles[i] == "3244") {
                this.globals.r3244 = true;
              }
              if (this.globals.roles[i] == "3246") {
                this.globals.r3246 = true;
              }
              if (this.globals.roles[i] == "3247") {
                this.globals.r3247 = true;
              }
            }
          },
          error: error => {
            this.errorMessage = error.message;
          }
        })
    }
  }

  ngOnInit() {
    this.http.get<any>(`${environment.baseUrl}v1/parametros/7?codigo=`)
      .subscribe({
        next: data => {
          this.Estados = data as Status[];
          //this.router.navigate(["/import-request/solicitud"]);
        },
        error: error => {
          this.errorMessage = error.message;
          //console.error('There was an error!', error);
        }
      })
  }

  /*name of the excel-file which will be downloaded. */
  fileName = 'ReporteImportaciones.xlsx';

  consultar() {
    var fechainicio = this.reportForm.controls["fechaInicio"].value;
    var fechafin = this.reportForm.controls["fechafin"].value;
    var estado = this.reportForm.controls["estadoimportacion"].value;

    this.http.get<any>(`${environment.baseUrl}v1/report/1?fechainicio=` + fechainicio + "&fechafin=" + fechafin + "&status=" + estado + "&sectional=" + this.globals.idSeccional)
      .subscribe({
        next: data => {
          this.Reports = data as Report[];
          this.reportForm.controls["fechaInicio"].disable();
          this.reportForm.controls["fechafin"].disable();
          this.reportForm.controls["estadoimportacion"].disable();
          this.ConsultarShow = false;
          let element: HTMLElement = document.getElementById('abrirmodal') as HTMLElement;
          element.click();
        },
        error: error => {
          this.errorMessage = error.message;
          //console.error('There was an error!', error);
        }
      })
  }

  limpiar() {
    this.reportForm.patchValue({
      fechaInicio: "",
      fechafin: "",
      estadoimportacion: ""
    });

    this.reportForm.controls["fechaInicio"].enable();
    this.reportForm.controls["fechafin"].enable();
    this.reportForm.controls["estadoimportacion"].enable();

    this.ConsultarShow = true;
  }

  exportexcel(): void {
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { dateNF: "dd/MM/yyyy", cellDates: true, cellStyles: true, raw: true });

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName, { cellDates: true, cellStyles: true });
  }
}

interface PortalBack {
  id: number;
  email: string;
}

class Report {
  id: string;
	sectionalAddressIn: string;
	sectionalAddressOut: string;
	touristName: string;
	touristCountry: string;
	passportNumber: string;
	nationality: string;
  dateOfArrival: string;
	touristCity: string;
	touristAddress: string;
	authorizedDuration: string;
	email: string;
  dateIn: string;
  dateOut: string;
	vehicleEntryForm: string;
	transportDocumentNumber: string;
	n1166DocumentNumber: string;
	ownershipDocumentNumber: string;
  registrationDate: string;
	typeClass: string;
	chassisNumber: string;
	licensePlate: string;
	make: string;
	model: string;
	engineNumber: string;
	countryOfRegistration: string;
	color: string;
	transportationName: string;
	nameFlag: string;
	entryPlace: string;
	registrationNumber: string;
	transportationChars: string;
	othersChars: string;
	status: string;
  importDate: string;
  statusDate: string;
  approvedNumberImport: string;
  approvedDateImport: string;
  justificationRejection: string;
  typeVehicle: string;

	idExtend: string;
	sectionalAddress: string;
	authorizedDurationExtend: string;
  initialDate: string;
  endDate: string;
	touristCityExtend: string;
	touristAddressExtend: string;
	justification: string;
	authorization: string;
	tidAssignee: string;
	idAssignee: string;
	nameAssignee: string;
	emailAssignee: string;
  registrationDateExtend: string;
  approvedNumberExtend: string;
  approvedDateExtend: string;
  justificationRejectionExtend: string;
  statusExtend: string;

	idFinish: string;
	finishType: string;
  finishDate: string;

  managerUserNameImport: string;
	managerUserIdImport: string;
	managerUserNameExtend: string;
	managerUserIdExtend: string;
	managerUserNameFinish: string;
	managerUserIdFinish: string;
}

interface Status {
  codigo: string;
  nombre: string;
}

class User {
  idToken: string;
  clientId: string;
  tipoDocumento: string;
  numIdentificacion: string;
  nombres: string;
  apellidos: string;
  seccional: string;
  idSeccional: string;
  dependencia: string;
  idDependencia: string;
  correo: string;
  activo: string;
  rolesAutorizados: string;
  infouser: string;
}
